"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATIC_PARTIAL_MYID_USERS = void 0;
const user_1 = require("../user");
exports.STATIC_PARTIAL_MYID_USERS = [
    {
        given_name: 'Matt',
        family_name: 'Blank',
        'relationship.employeeId': 'BLANM118',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Maddy',
        family_name: 'Baim',
        'relationship.employeeId': 'BAIMM002',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Leslie',
        family_name: 'Foster',
        'relationship.employeeId': 'FOSTH014',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_QA],
    },
    {
        given_name: 'Paola',
        family_name: 'Cutri',
        'relationship.employeeId': 'CUTRP002',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Erik',
        family_name: 'Avellaneda',
        'relationship.employeeId': 'AVELE004',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Colleen',
        family_name: 'Watson',
        'relationship.employeeId': 'WATSC079',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Karisa',
        family_name: 'Bruin',
        'relationship.employeeId': 'BRUIK002',
        roles: [user_1.ROLE_QA],
    },
    {
        given_name: 'Sean',
        family_name: 'Costello',
        'relationship.employeeId': 'COSTS046',
        roles: [user_1.ROLE_QA],
    },
    {
        given_name: 'Kris',
        family_name: 'Miranda',
        'relationship.employeeId': 'MIRAK021',
        roles: [user_1.ROLE_QA],
    },
    {
        given_name: 'Scott',
        family_name: 'Morehead',
        'relationship.employeeId': 'MORES103',
        roles: [user_1.ROLE_QA],
    },
    {
        given_name: 'Sean',
        family_name: 'Persaud',
        'relationship.employeeId': 'PERSS019',
        roles: [user_1.ROLE_QA],
    },
    {
        given_name: 'Courteney',
        family_name: 'Merritt',
        'relationship.employeeId': 'MERRC033',
        roles: [user_1.ROLE_ADMIN],
    },
    {
        given_name: 'Melina',
        family_name: 'Ovanessian',
        'relationship.employeeId': 'OVANM001',
        roles: [user_1.ROLE_ADMIN],
    },
    {
        given_name: 'Muller',
        family_name: 'Bisrat',
        'relationship.employeeId': 'BISRM001',
        roles: [user_1.ROLE_ADMIN],
    },
    {
        given_name: 'Ivan',
        family_name: 'Tanev',
        'relationship.employeeId': 'TANEI001',
        roles: [user_1.ROLE_ADMIN],
    },
];
//# sourceMappingURL=static-partial-myid-users.js.map